import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Modal from '../../Modal/Modal';
import ModalBody from '../../Modal/ModalBody';
import ModalButtons from '../../Modal/ModalButtons';
import themeColors from '../../../assets/styles/themeColors';
import { pxToRem } from '../../../assets/styles/helper';
import { ReactComponent as AlertTriangle } from '../../../assets/images/svg/alert-triangle.svg';
import { ReactComponent as Close } from '../../../assets/images/svg/close.svg';
import IconButton from '../../IconButton/IconButton';

const CloseButton = styled(IconButton)`
  position: absolute;
  top: ${pxToRem(12)};
  right: ${pxToRem(12)};

  &,
  svg {
    width: ${pxToRem(16)};
    height: ${pxToRem(16)};
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${pxToRem(8)};
  margin-bottom: ${pxToRem(12)};

  svg {
    width: ${pxToRem(20)};
    height: ${pxToRem(20)};
    flex-shrink: 0;
    color: ${themeColors.colorWarning};
  }
`;

const Title = styled.h4`
  font-size: ${pxToRem(16)};
  font-weight: 600;
  color: ${themeColors.colorTextPrimary};
  margin: 0;
`;

const Description = styled.p`
  color: ${themeColors.colorTextSecondary};
  font-size: ${pxToRem(14)};
  line-height: 1.6;
  margin-bottom: ${pxToRem(16)};
`;

const ActionRequiredModal = ({ isOpen, close }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      size="sm"
      close={close}
      hideHeader
      verticalCenter
      avoidClearingStorage
      skipListeningToLocations
    >
      <ModalBody>
        <CloseButton onClick={close} data-cy="button-close-modal">
          <Close />
        </CloseButton>
        <TitleWrapper>
          <AlertTriangle />
          <Title>{t('actionRequiredModal.title')}</Title>
        </TitleWrapper>
        <Description>{t('actionRequiredModal.description')}</Description>
        <ModalButtons
          isVertical
          showOnlyPrimary
          primaryButtonProps={{
            label: t('actionRequiredModal.callUs'),
            onClick: () => {
              window.location.href = 'tel:8777277387';
            },
          }}
        />
      </ModalBody>
    </Modal>
  );
};

ActionRequiredModal.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
};

export default ActionRequiredModal;
